const AWS = require('aws-sdk');

const getStorage = () => new AWS.S3();

const updateConfiguration = (...args) => AWS.config.update(...args);

export default { getStorage, updateConfiguration };
